import { default as specialdaysTypes } from "./types";

const {
  ADD_SPECIALDAY_REQUEST,
  ADD_SPECIALDAY_SUCCESS,
  ADD_SPECIALDAY_FAILURE,
  FETCH_SPECIALDAYS_REQUEST,
  FETCH_SPECIALDAYS_SUCCESS,
  FETCH_SPECIALDAYS_FAILURE,
} = specialdaysTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SPECIALDAY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_SPECIALDAY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_SPECIALDAY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_SPECIALDAYS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SPECIALDAYS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_SPECIALDAYS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
